import moment from 'moment';
import { BROWSER_NAME } from './constants';

export const validEmail = (email) => {
  if (!/\S+@\S+\.\S+/.test(email)) {
    return true
  }
  return false
}

export const validPhone = (phone) => {
  if (!/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone)) {
    return true
  }
  return false
}

export const isNumber = (number) => {
  if (!/^[0-9]+$/.test(number)) {
    return true
  }
  return false
}

export const isRequired = (value) => {
  if (!value || value == '') {
    return true
  }
  return false
}

export const createTableData = (originalData, modal) => {
  let tableData = [];
  if (originalData) {
    let tableKeys = Object.keys(modal);

    for (let i in originalData) {
      let tableKeysObject = {}
      tableKeys.map((ele) => {

        if (ele == 'createdAt' || ele == 'updatedAt') {
          originalData[i][ele] = moment(originalData[i][ele]).format('DD/MM/YYYY')
        }
        if (originalData[i][ele] === true) {
          originalData[i][ele] = 'Yes'
        } else if (originalData[i][ele] === false) {
          originalData[i][ele] = 'No'
        }

        tableKeysObject[ele] = originalData[i][ele]
        return
      })

      tableData.push(tableKeysObject);
    }
  }
  return tableData
}

export const makeQueryParams = (defaultParams, requestParams) => {
  let queryParams = Object.assign({}, defaultParams)
  let queryString = '?';
  Object.keys(defaultParams).map((ele) => {
    if (requestParams[ele]) {
      queryParams[ele] = requestParams[ele];
      queryString = queryString + `${ele}=${requestParams[ele]}&`
    } else {
      queryString = queryString + `${ele}=${queryParams[ele]}&`
    }
  })
  queryString = queryString.substring(0, queryString.length - 1);
  return queryString
}

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function showLocation(position) {
  let latitude = position.coords.latitude;
  let longitude = position.coords.longitude;
  return {
    latitude,
    longitude
  };
}

function errorHandler(err) {
  if (err.code == 1) {
    alert("Error: Access is denied!");
  } else if (err.code == 2) {
    alert("Error: Position is unavailable!");
  }
}

export const getLocation = () => {
  if (navigator.geolocation) {

    // timeout at 60000 milliseconds (60 seconds)
    let options = { timeout: 60000 };
    navigator.geolocation.getCurrentPosition(showLocation, errorHandler, options);
  } else {
    alert("Sorry, browser does not support geolocation!");
  }
}

export const findBrowser = () => {
  let browserName = BROWSER_NAME.CHROME;

  // Firefox 1.0+
  let isFirefox = typeof InstallTrigger !== 'undefined';

  //For safari
  let ua = window.navigator.userAgent;
  let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  let webkit = !!ua.match(/WebKit/i);
  let isSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/Chrome/i);

  //For Vivo Browser
  let isVivo = !!ua.match(/VivoBrowser/i);

  //For chrome
  let isChrome = !!ua.match(/CriOS/i) || !!ua.match(/Chrome/i) || /Google Inc/.test(navigator.vendor);

  if (isFirefox) {
    browserName = BROWSER_NAME.FIREFOX;
  } else if (isVivo) {
    browserName = BROWSER_NAME.VIVO;
  } else if (isSafari) {
    browserName = BROWSER_NAME.SAFARI
  } else if (isChrome) {
    browserName = BROWSER_NAME.CHROME
  }
   return browserName;
}

export function round(value, decimals) {
  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}
